/** Dashboard fields read by the tab ordering. */
export type OrderableDashboard = {
  id: string | number
  pivot?: {
    position?: number | null
    local_position?: number | null
  } | null
}

/**
 * Comparator ordering dashboards by a pivot position (`position` for favorites,
 * `local_position` for a single dashboard type). Dashboards without a position
 * come last; ties are broken by id so the order is total and stable (BBSW-11320:
 * the previous comparator returned 1 for two missing positions, an invalid
 * ordering that shuffled predefined dashboards).
 */
export function compareByPosition(
  field: 'position' | 'local_position'
): (first: OrderableDashboard, second: OrderableDashboard) => number {
  return (first, second) => {
    const firstPosition = first.pivot?.[field] ?? null
    const secondPosition = second.pivot?.[field] ?? null

    if (firstPosition !== secondPosition) {
      if (firstPosition === null) return 1
      if (secondPosition === null) return -1
      return firstPosition - secondPosition
    }

    return String(first.id).localeCompare(String(second.id))
  }
}
